<template>
  <div class="power">
    <div class="index-header">
      <el-form :model="filterForm" :inline="true" label-width="120px">
        <div class="input-box">
          <div>
            <el-form-item label="账号名称：">
              <el-input clearable v-model="filterForm.name" placeholder="请输入账号名称"></el-input>
            </el-form-item>
            <el-form-item label="账号类型：">
              <el-select clearable filterable v-model="filterForm.organization">
                <el-option label="企业账号" :value="true"></el-option>
                <el-option label="个人账号" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账号级别：">
              <el-select clearable filterable v-model="filterForm.o_vipType">
                <el-option :label="x.label" :value="x.value" v-for="(x,i) in vipTypeArr" :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="企业名称：">
              <el-input clearable v-model="filterForm.o_name" placeholder="请输入企业名称"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <areaFilter ref="areaFilter_filter" @getData="filterClick" />
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click="filterClick()" icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" type="primary" @click="setArea()" v-if="userInfo.admin">修改地区</el-button>
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" type="primary" @click="setPower()">用户权限</el-button>
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" type="primary" @click="changeBox()">用户密码</el-button>
      <el-button :disabled="!selectRow.length" icon="el-icon-delete" type="danger" @click="deleteUser()" v-if="isShow.deleteUser">删除</el-button>
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" type="success" @click="vipFormVisible=true" v-if="isShow.setVip">VIP类型</el-button>
      <el-button :disabled="selectRow.length!==1||!selectRow[0].workPerson" icon="el-icon-edit" type="success" @click="assignHandler('user')" v-if="isShow.assignUser">分配人员</el-button>
      <el-button :disabled="selectRow.length!==1||!selectRow[0].workPerson" icon="el-icon-edit" type="success" @click="assignHandler('organization')" v-if="isShow.assignOrganization">分配企业</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" max-height="550" @selection-change="handleSelectionChange" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip align="center"
          v-for="x in baseInfo" :key="x.key"
          :prop="x.key" :label="x.value">
        </el-table-column>
        <el-table-column label="账号级别" width="" align="center">
          <template slot-scope="scope">
            <span
              :style="[
                'color:black;',
                'color:red;',
                'color:DeepSkyBlue;',
                'color:orange;',
                'color:LimeGreen;',
              ][scope.row.o_vipType]">{{scope.row.vipLevel}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="o_vipEndTime" label="到期时间">
        </el-table-column>
        <el-table-column label="工作人员" width="" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.workPerson">工作人员</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="warning" @click="workerHandler(scope.row.id,false)" v-if="scope.row.workPerson">取消工作人员</el-button>
            <el-button size="mini" plain type="success" @click="workerHandler(scope.row.id,true)" v-else>设置工作人员</el-button>
            <el-button size="mini" plain type="primary" @click="modifyInfoHandler(scope.row)" v-if="isShow.modifyInfo">修改信息</el-button>
            <el-button size="mini" plain type="primary" @click="modifyToppingHandler(scope.row)" v-if="isShow.modifyTopping">置顶权重</el-button>
          </template>
        </el-table-column>
      </el-table>
      <paging :pagesData="pageData" @set_page_number='pageChange'></paging>
    </div>
    <!-- 权限框 -->
    <el-dialog :visible.sync="centerDialogVisible" width="500px" :model="false" center :close-on-click-modal="false">
      <span slot="title" style="font-size:16px;">
        <span style="color:#409EFF;"><i class="el-icon-s-promotion"></i></span>权限管理
      </span>
      <el-form ref="powerForm" :model="powerForm" label-width="100px">
        <el-form-item label="角色分配：">
          <el-select v-model="powerForm.role" @change="changeRole" @remove-tag="removeRole" multiple placeholder="请选择">
            <el-option
              v-for="item in roleArr"
              :key="item.name"
              :label="item.name"
              :value="item.privilegesList.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权限设置：">
          <div class="power-box">
            <div class="power-right">
              <el-tree 
                :data="powerData" 
                show-checkbox 
                node-key="id" 
                ref="tree" 
                :props="defaultProps" 
                :default-checked-keys="checkedPower"></el-tree>
            </div>
          </div>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 密码框 -->
    <el-dialog title="密码修改" width="500px" label-width="100px" :visible.sync="dialogFormVisible">
      <el-form :model="passInfo" ref="passInfo" label-width="100px" class="demo-ruleForm">    
        <el-form-item label="新密码：" prop="password">
          <el-input v-model="passInfo.password" type="password" :rules="[{required: true,message: '请输入密码',trigger: 'blur'}]" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureChange()">修 改</el-button>
      </div>
    </el-dialog>
    <!-- VIP框 -->
    <el-dialog title="设置企业VIP类型" width="400px" label-width="100px" :visible.sync="vipFormVisible">
      <el-form :model="vipForm" ref="vipForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="VIP类型：">
          <el-select v-model="vipForm.o_vipType" clearable style="width:180px;">
            <el-option v-for="(x,i) in vipTypeArr" :key="i" :label="x.label" :value="x.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间：">
          <el-date-picker v-model="vipForm.o_vipEndTime" type="date" value-format="timestamp" style="width:180px;"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="vipFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitVipType()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 分配 -->
    <el-dialog
      title="分配账号" :modal="false" width="900px" center :visible.sync="assignDialogVisible"
      :close-on-click-modal="false" @close="dialogClose">
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-form-item label="选择地区">
                        <areaFilter ref="areaFilter_dialog" :areaIdsChecked="areaIdsChecked" />
                      </el-form-item>
                      <el-form-item label="起始：" prop="startNo">
                        <el-input v-model.number="editForm.startNo"></el-input>
                      </el-form-item>
                      <el-form-item label="终止：" prop="endNo">
                        <el-input v-model.number="editForm.endNo"></el-input>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose()">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 超管修改地区 -->
    <DialogEdit
      ref="DialogEdit"
      dialogWidth="800px"
      dialogTitle="修改地区"
      :action="$api.url_upload_pu"
      :formItems="[]"
      :formItems2="null"
      @submitHandler="editAreaSubmitHandler"
      :isShowArea="true" />
    <!-- 修改账号信息 -->
    <DialogEdit
      ref="DialogEdit2"
      :dialogWidth="dialogWidth"
      dialogTitle="修改账号信息"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editInfoSubmitHandler" />
      <!-- :isShowArea="true" -->
      <!-- 修改账号信息 -->
    <DialogEdit
      ref="DialogEdit3"
      :dialogWidth="dialogWidth"
      dialogTitle="修改置顶权重"
      :action="$api.url_upload_pu"
      :formItems="formItems_topping"
      :formItems2="null"
      @submitHandler="editToppingSubmitHandler" />
  </div>
</template>

<script>
import areaFilter from '@/components/areaFilter'
import DialogEdit from '@/components/DialogEdit'
import mixins from '@/Mixins/mixin_com'
import { powerData } from '@/publicData/powerData'
export default {
  mixins: [mixins],
  components: { areaFilter, DialogEdit },
  data() {
    return {
      filterForm: {}, // 筛选数据
      tableData: [], // 表格数据
      selectRow: [], // 表格选中行数据
      editForm: {}, // 表格选中行编辑数据
      assignDialogVisible: false,

      pageData: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      powerForm: {},//权限表单
      dialogFormVisible: false,//密码框的显隐
      form: {},
      centerDialogVisible: false,//权限框的显隐
      passInfo: {id: '',password: ''},//密码表单

      vipFormVisible: false,//用户类型设置框的显隐
      vipForm: {},//设置用户类型表单
      vipTypeArr: [{label:'钻石VIP',value:1},{label:'铂金VIP',value:2},{label:'黄金VIP',value:3},{label:'普通VIP',value:4},{label:'普通用户',value:0},],

      baseInfo: [
        { key: 'name', value: '账号' },
        { key: 'areaName', value: '地区' },
        // { key: 'belongTo', value: '所属分站' },
        { key: 'userType', value: '账号类型' },
        { key: 'o_name', value: '企业名称' },
        { key: 'show', value: '置顶权重' },
        // { key: 'vipLevel', value: '账号级别' },
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      checkedPower: [],//选中用户拥有权限的数组
      powerData: powerData,
      powerDataCopy: powerData,//备份,切换用户到管理员时,将之赋给遍历的powerData
      roleArr: [],//显示 角色

      areaIdsChecked: [],
      isShow: {
        setVip: false,
        deleteUser: false,
        assignUser: false,
        assignOrganization: false,
        modifyInfo: false,
        modifyTopping: false,
      },


      formItems_organization: [
        // { type: 'number', key: 'show', label: '置顶权重' },
        { type: 'text', key: 'o_name', label: '企业名称', disabled: true },
        { type: 'select_s', key: 'o_domain', label: '所属行业', options: this.$fuwuData.suoshuhangye3g_ },
        { type: 'select_s', key: 'o_type', label: '企业性质', options: this.$fuwuData.companyType },
        { type: 'date', key: 'o_publicTime', label: '成立时间' },
        { type: 'text', key: 'o_registerCash', label: '注册资金' },
        { type: 'text', key: 'o_person', label: '员工人数' },
        { type: 'text', key: 'o_phone', label: '企业电话' },
        { type: 'text', key: 'o_fax', label: '企业传真' },
        { type: 'text', key: 'o_QQ', label: '企业QQ' },
        { type: 'text', key: 'o_weixin', label: '企业微信' },
        { type: 'image', key: 'o_homeUrl', label: '企业logo', size: '无', limitNum: 1, index: 1 },
        { type: 'image', key: 'o_signatureUrl', label: '电子签名', size: '无', limitNum: 1, index: 2 },
        { type: 'text', key: 'o_socialCode', label: '企业信用代码' },
        { type: 'text', key: 'o_address', label: '企业地址' },
        { type: 'textarea', key: 'o_description', label: '企业简介' },
        { type: 'video', key: 'o_videoUrl', label: '视频简介', limitNum: 1, index: 3 },
      ],
      formItems_personal: [
        // { type: 'number', key: 'show', label: '置顶权重' },
        { type: 'text', key: 'u_nickName', label: '姓名' },
        { type: 'text', key: 'u_description', label: '座右铭' },
        { type: 'text', key: 'u_fixPhone', label: '固定电话' },
        { type: 'text', key: 'u_phone', label: '手机号码' },
        { type: 'text', key: 'u_email', label: '邮箱' },
        { type: 'text', key: 'u_QQ', label: 'QQ号码' },
        { type: 'text', key: 'u_weixin', label: '微信' },
        { type: 'text', key: 'u_weibo', label: '微博' },
        { type: 'select_s', key: 'u_sex', label: '性别', options: this.$fuwuData.sex },
        { type: 'text', key: 'u_height', label: '身高', placeholder: '以厘米为单位' },
        { type: 'date', key: 'u_birthDayString', label: '出生日期' },
        { type: 'text', key: 'u_idCard', label: '身份证' },
        { type: 'text', key: 'u_liveAddress', label: '所在地区' },
        { type: 'image', key: 'o_homeUrl', label: '个人logo', size: '无', limitNum: 1, index: 1 },
        { type: 'image', key: 'o_signatureUrl', label: '背景图', size: '无', limitNum: 1, index: 2 },
        { type: 'select_s', key: 'u_education', label: '学历', options: this.$fuwuData.education_ },
        { type: 'text', key: 'u_major', label: '专业' },
        { type: 'text', key: 'u_school', label: '毕业院校' },
        { type: 'select_s', key: 'u_putonghua', label: '普通话', options: this.$fuwuData.ability },
        { type: 'select_s', key: 'u_waiyu', label: '外语能力', options: this.$fuwuData.ability },
        { type: 'select_s', key: 'u_marriage', label: '婚否', options: this.$fuwuData.ismarriage },
      ],
      selectData: {
        personal: true
      },
      selectData_ori: {},
      formItems_topping: [
        { type: 'number', key: 'show', label: '置顶权重' },
      ],
    }
  },
  computed: {
    formItems() {
      if (this.selectData.organization) {
        return this.formItems_organization
      } else if (this.selectData.personal) {
        return this.formItems_personal
      }
    },
    formItems2() {
      if (this.selectData.organization) {
        return null
      } else if (this.selectData.personal) {
        return [
          { type: 'switch', key: 'u_startGetJob', label: '求职状态' },
          { type: 'text', key: 'u_expectSalary', label: '期望薪资' },
          { type: 'select_s', key: 'u_workYear', label: '工作经验', options: this.$fuwuData.workexperience },
          { type: 'select_s', key: 'u_jobType', label: '职业类别', options: this.$fuwuData.zhiweileibie },
          { type: 'text', key: 'u_expectJob', label: '期望职位' },
          { type: 'video', key: 'o_videoUrl', label: '视频简介', limitNum: 1, index: 3 },
          { type: 'textarea', key: 'u_educationExperience', label: '教育经历' },
          { type: 'textarea', key: 'u_workExperience', label: '工作经历' },
          { type: 'textarea', key: 'selfComments', label: '自我评价' },
          { type: 'document', key: 'u_resumeNameAndIds', label: '个人简历', limitNum: 1, index: 4 },
          { type: 'switch', key: 'openFriends', label: '公开交友' },
          { type: 'text', key: 'f_age', label: '年龄', placeholder: '岁' },
          { type: 'text', key: 'f_weight', label: '体重', placeholder: '公斤' },
          { type: 'text', key: 'f_disposition', label: '性格' },
          { type: 'text', key: 'f_friends', label: '交友方式' },
          { type: 'text', key: 'f_wordAddress', label: '工作地点' },
          { type: 'textarea', key: 'f_requirement', label: '交友要求' },
          { type: 'textarea', key: 'f_secDoc', label: '秘密档案' },
          { type: 'textarea', key: 'f_description', label: '自我介绍' },
        ]
      }
    },
    dialogWidth() {
      if (this.selectData.organization) {
        return '800px'
      } else if (this.selectData.personal) {
        return '1600px'
      }
    }
  },
  watch: {
    centerDialogVisible(val) {
      if (val === true) {
        // console.log(this.selectRow[0].privilegesList)
        this.checkedPower = this.selectRow[0].privilegesList != '' ? JSON.parse(JSON.stringify(this.selectRow[0].privilegesList)) : []
      } else {
        this.checkedPower = []
        this.powerForm.role=[]
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.checkedPower)
        })
      }
    },
    vipFormVisible(val) {
      if (val == true) {
        let type = this.selectRow[0].o_vipType
        this.$set(this.vipForm, 'o_vipType', type)
      } else {
        this.vipForm = {}
      }
    }
  },
  methods: {
    // ———————————————————————— 12.04 修改账号信息 s ————————————————————————
    modifyToppingHandler(row) {
      console.log(row)
      this.selectData = row
      this.selectData_ori = JSON.parse(JSON.stringify(row))
      this.$refs.DialogEdit3.modifyHandler(row)
    },
    editToppingSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let rD = {}
      let mapList = [//以下属性是，发生改变的时候才传
        'show',
      ]

      mapList.forEach(x => {//将修改过的属性和值赋给rD
        result[x] != this.selectData_ori[x] ? rD[x] = result[x] : ''
      })
      if (JSON.stringify(rD.u_resumeNameAndIds) === '{}') {
        delete rD.u_resumeNameAndIds
      }

      rD.id = result.id
      console.log(rD)
      this.$api.editUserTopping(rD).then(res =>{
        if (res.data.status === 0) {
          this.$message.success('修改成功!')
          let index = this.tableData.findIndex(x => x.id === result.id)
          // this.tableData[index] = result
          this.$refs.DialogEdit3.isShowDialog = false
          this.$refs.DialogEdit3.clearHandler()
          this.$set(this.tableData, index, result)
        } else { this._status(res.data) }
      })
    },
    // ———————————————————————— 12.04 修改账号信息 e ————————————————————————
    // ———————————————————————— 12.02 修改账号信息 s ————————————————————————
    modifyInfoHandler(row) {
      console.log(row)
      this.selectData = row
      this.selectData_ori = JSON.parse(JSON.stringify(row))
      this.$refs.DialogEdit2.modifyHandler(row)
    },
    editInfoSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let rD = {}
      let mapList = [//以下属性是，发生改变的时候才传
        'show',
        'o_name', 
        'o_domain',
        'o_type',
        'o_publicTime',
        'o_registerCash',
        'o_person',
        'o_homeUrl',
        'o_socialCode',
        'o_address',
        'o_description',
        'o_videoUrl',
        'o_socialCodeUrl',
        'o_signatureUrl',
        'o_idCardFront',
        'o_idCardBack',
        'o_confirm',
        'o_phone',
        'o_fax',
        'o_QQ',
        'o_weixin',
        
        'u_nickName',
        'u_description',
        'u_fixPhone',
        'u_phone',
        'u_email',
        'u_QQ',
        'u_weixin',
        'u_weibo',
        'u_sex',
        'u_height',
        'u_birthDayString',
        'u_idCard',
        'u_liveAddress',
        'o_homeUrl',
        'o_signatureUrl',
        'u_education',
        'u_major',
        'u_school',
        'u_putonghua',
        'u_waiyu',
        'u_marriage',
        'u_startGetJob',
        'u_expectSalary',
        'u_workYear',
        'u_jobType',
        'u_expectJob',
        'o_videoUrl',
        'u_educationExperience',
        'u_workExperience',
        'selfComments',
        'u_resumeNameAndIds',
        'openFriends',
        'f_age',
        'f_weight',
        'f_disposition',
        'f_friends',
        'f_wordAddress',
        'f_requirement',
        'f_secDoc',
        'f_description',
      ]

      mapList.forEach(x => {//将修改过的属性和值赋给rD
        result[x] != this.selectData_ori[x] ? rD[x] = result[x] : ''
      })
      if (JSON.stringify(rD.u_resumeNameAndIds) === '{}') {
        delete rD.u_resumeNameAndIds
      }

      rD.id = result.id
      console.log(rD)
      this.$api.editUserList(rD).then(res =>{
        if (res.data.status === 0) {
          this.$message.success('修改成功!')
          let index = this.tableData.findIndex(x => x.id === result.id)
          // this.tableData[index] = result
          this.$refs.DialogEdit2.isShowDialog = false
          this.$refs.DialogEdit2.clearHandler()
          this.$set(this.tableData, index, result)
        } else { this._status(res.data) }
      })
    },
    // ———————————————————————— 12.02 修改账号信息 e ————————————————————————
    // ———————————————————————— 10.26 超管修改地区 s ————————————————————————
    setArea() {
      console.log(`%crow:`, 'color: #00f;', this.selectRow)
      this.selectData = this.selectRow[0]
      if (this.selectData) {
        let { provinceId, cityId, countyId, townId, villageId } = this.selectData
        let areaIds = [ provinceId, cityId, countyId, townId, villageId ]
        this.areaIdsChecked = areaIds.filter(x => !!x)
        console.log(areaIds, this.areaIdsChecked)

        this.$refs.DialogEdit.modifyHandler(this.selectData)
      }
    },
    editAreaSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      // console.log(result, this.selectData)
      let rData = {}
      // let areaId = this.$refs.AreaPicker.findAreaId()
      let {
        id,
        province,
        city,
        county,
        town,
        village,
      } = result
      // if (this.isCreate) {
      //   rData = {
      //     companyName,
      //   }
      //   // console.log(rData)
        
      //   this.$api.util_create(this.sign, rData).then(res => {
      //     if (res.data.status == 0) {
      //       this.$message.success('新建成功')
      //       this.$refs.DialogEdit.isShowDialog = false
      //       this.$refs.DialogEdit.clearHandler()
      //       this.searchHandler()
      //     } else { this._status(res.data) }
      //   })
      // }

      // else {
        const mapList = [
          'province',
          'city',
          'county',
          'town',
          'village',
        ]
        mapList.forEach(x => {
          // if (this.selectData[x] !== result[x]) {
            rData[x] = result[x] || ''
          // }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
        console.log(`%crData:`, 'color: #00f;', rData)

        this.$api.editUserList(rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.filterClick()
          } else { this._status(res.data) }
        })
      // }
    },
    // ———————————————————————— 10.26 超管修改地区 e ————————————————————————
    // ———————————————————————— 9.14 分配 s ————————————————————————
    assignHandler(type) {
      this.assignType = type
      this.assignDialogVisible = true
      this.editForm = this.selectRow[0]
      let {
        provinceId,
        cityId,
        countyId,
        townId,
        villageId,
      } = this.editForm
      this.areaIdsChecked = [
        provinceId,
        cityId,
        countyId,
        townId,
        villageId,
      ]
      console.log(this.areaIdsChecked)
    },
    // 关闭弹框
    dialogClose() {
      this.assignDialogVisible = false
      this.editForm = {}
    },
    dialogSubmit() {
      let rD = {}

      // const mapList = ['province','city','county','town','village']
      // const mapList2 = [
      //   'startNo',
      //   'endNo',
      // ]
      // let areaNames = this.$refs.areaFilter_dialog.findAreaNames()
      // console.log(areaNames)
      // areaNames.forEach((x, i) => {
      //   x ? rD[mapList[i]] = x : ''
      // })
      let { startNo, endNo } = this.editForm

      rD.areaId = this.$refs.areaFilter_dialog.findAreaId()
      console.log(rD.areaId, this.editForm)

      if (!rD.areaId) { this.$message.warning('请选择地区') }
      else if (startNo === '' || startNo === undefined) { this.$message.warning('请输入起始数字') }
      else if (endNo === '' || endNo === undefined) { this.$message.warning('请输入终止数字') }
      else {
        rD.startNo = startNo
        rD.endNo = endNo
        rD.userId = this.editForm.id
        console.log(`%crD:`, 'color: #f00;', rD)
        
        // mapList2.forEach(x => {
        //   rD[x] = this.editForm[x]
        // })
        if (this.assignType === 'user') {
          console.log(`%cthis.$api:`, 'color: #f00;', this.$api)
          this.$api.assign_user(rD).then(res => {
            if (res.data.status == 0) {
              this.$message.success('分配成功')
              this.dialogClose()
            } else { this._status(res.data) }
          })
        } else {
          this.$api.assign_organization(rD).then(res => {
            if (res.data.status == 0) {
              this.$message.success('分配成功')
              this.dialogClose()
            } else { this._status(res.data) }
          })
        }
      }
    },
    
    workerHandler(id, workPerson) {
      let rD = { id, workPerson }
      this.$api.editUserList(rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('设置成功!')
          this.filterHandler()
        } else { this._status(res.data) }
      })
    },
    // ———————————————————————— 9.14 分配 e ————————————————————————
    // ———————————————————————— 10.12 设置vip s ————————————————————————
    //提交设置用户类型的表单
    submitVipType() {
      // console.log(`%cthis.vipForm:`, 'color: #f00;', this.vipForm)
      let { o_vipType, o_vipEndTime } = this.vipForm
      if (o_vipType === '') { this.$message.warning('请选择用户类型') }
      else if (o_vipType && !o_vipEndTime) { this.$message.warning('请选择到期时间') }
      else {
        this.vipForm.id = this.selectRow[0].id
        this.$api.setVip(this.vipForm).then(res => {
          if (res.data.status == 0) {
            this.$message.success('设置成功!')
            this.filterHandler()
            this.vipFormVisible = false 
          } else { this._status(res.data) }
        })
      }
    },
    // ———————————————————————— 10.12 设置vip e ————————————————————————
    filterClick(areaId) {
      this.pageData.currentPage = 1
      this.filterHandler(areaId)
    },
    filterHandler(areaId) {
      areaId ? '' : areaId = this.$refs.areaFilter_filter.findAreaId()
      let rD = {}
      let keys = Object.keys(this.filterForm)
      if (keys.length > 0) {
        keys.forEach(x => {
          if (this.filterForm[x] || this.filterForm[x] === false) {
            rD[x] = this.filterForm[x]
          }
        })
      }
      if (areaId) {
        rD.areaId = areaId
        // console.log(rD)
        this.getData(rD)
      } else { this.$message.warning('请选择地区') }
    },
    // 获取表格数据
    getData(rD = {}) {
      rD.pageSize = this.pageData.pageSize
      rD.pageNumber = this.pageData.currentPage
      this.getDataCb(rD)
    },
    getDataCb(rD = {}) {
      const mapList = ['普通用户','钻石VIP','铂金VIP','黄金VIP','普通VIP',]
      this.$api.getUserList(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.tableData = _R
          this.tableData.forEach(x => {
            x.vipLevel = mapList[x.o_vipType]
            x.o_publicTime = new Date(x.o_publicTime).getTime()
            x.userType = x.admin ? '超级管理员' : x.organization ? '企业账号' : '个人账号'
            x.areaName = x.province + x.city + x.county + x.town + x.village
          })
          this.pageData.total = res.data.size
          console.log(`%c返回数据:`, 'color: #f00;', this.tableData)
        } else { this._status(res.data) }
      })
    },

    //获取选中的数据
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //权限选择
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
    },
    getCheckedKeys() {
      console.log(this.$refs.tree.getCheckedKeys())
    },
    //分页
    pageChange(pageNumber) {
      this.pageData.currentPage = pageNumber
      this.filterHandler()
    },
    //点击设置用户权限时,主要是获取该用户创建的角色，将之动态渲染到下拉框
    setPower() {
      this.centerDialogVisible = true
      //得到 该用户创建的角色列表
      let data = {}
      data.userId = this.userInfo.id
      this.$api.getRole(data).then(res => {
        if (res.data.status == 0) {
          this.roleArr = JSON.parse(res.data.data)
        } else {
          this._status(res.data)
        }
      })
    },
    //角色   下拉框发生发生改变时，触发。但是当减少角色个数时，此函数达不到相应的效果
    changeRole(val) {
      this.powerForm.role.forEach( e1 => {
        e1.split(',').forEach( e2 => {
          this.checkedPower.indexOf(e2) == -1 ? this.checkedPower.push(e2) :''
        })
      })
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkedPower);
      });
    },
    //减少角色时
    removeRole(tag) {
      let arr = tag.split(',')
      arr.forEach( x => {
        this.checkedPower.splice(this.checkedPower.indexOf(x),1)
      })
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkedPower);
      });
    },

    //设置权限
    submit() {
      let privilegesList = this.$refs.tree.getCheckedKeys().filter(x => x.indexOf('Lose') == -1)
      let data = { privilegesList, id: this.selectRow[0].id }
      console.log(this.powerForm)
      console.log(`%cdata:`, 'color: #f00;', data)
      this.$api.editUserList(data).then(res => {
        console.log(res)
        if (res.data.status == 0) {
          this.$message.success('设置成功！')
        } else { this._status(res.data) }
        this.filterHandler()
        this.centerDialogVisible = false
      })
    },
    //修改密码框
    changeBox() {
      this.passInfo.password = ''
      this.dialogFormVisible = true
      this.passInfo.id = this.selectRow[0].id
    },
    //确认修改密码
    sureChange() {
      if (this.passInfo.password === '') {
        return this.$message.warning('您还未输入密码')
      } else {
        console.log(this.passInfo)
        this.$api._user_modify(this.passInfo).then(res => {
          res.data.status === 0 ? this.$message.success('修改成功！') : this._status(res.data)
          
          this.dialogFormVisible = false
        })
        // this.$api.changeOrtherPass(this.passInfo).then(res => {
        //   res.data.status === 0?this.$message.success('修改成功！') :this.$message.error('修改失败！')
        //   this.dialogFormVisible = false
        // })
      }
    },
    //搜索用户
    // searchUser() {
    //   this.pageData.currentPage = 1
    //   this.filterHandler()
    // },
    //删除用户
    deleteUser() {
      let ids = this.selectRow.map(i => i.id)
      this.selectRow.length === 0  
        ? this.$message.error('请至少勾选一条数据') 
        : this.$confirm('确认删除数据?','提示',{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
            this.$api.deleteUser(ids).then(res => {
              if (res.data.status === 0 ) {
                this.$message.success('删除成功!')
                this.$data.pageData.total = this.$data.pageData.total - ids.length
                if (this.$data.pageData.total % this.$data.pageData.pageSize == 0) {//把当前页的所有数据都删除时，需要更换页码
                  if (this.$data.pageData.currentPage > 1) {
                    this.$data.pageData.currentPage--
                  } else {
                    this.$data.pageData.currentPage = 1
                  }
                }
                console.log('删除之后的总条数',this.$data.pageData.total,'当前页数',this.$data.pageData.currentPage)
                this.filterHandler()
              } else {
                this._status(res.data)
              }
            })
          }).catch(() => { this.$message.info('已取消删除') })
    },

    setPowerArr() {//根据登录账号的权限,来限制哪些权限不可选,在角色分配和权限设置里面被调用
      let dataArr = JSON.parse(JSON.stringify(this.powerData))
      if (!this.userInfo.admin) {
        //删除用户没有的权限
        dataArr.forEach(x1 => {
          x1.children.forEach(x2 => {
            if (x2.children) {
              x2.children.forEach(x3 => {
                let arr2 = x2.children.filter(obj => this.userInfo.privilegesList.indexOf(obj.id) !== -1)
                x2.children = arr2
              })
              let arr = x1.children.filter(obj => obj.children.length !== 0)
              x1.children = arr
            } else {
              let arr1 = x1.children.filter(obj => this.userInfo.privilegesList.indexOf(obj.id) !== -1)
              x1.children = arr1
            }
          })
          let arr4 = dataArr.filter(obj => obj.children.length !== 0)
          dataArr = arr4
        })

        this.powerData = dataArr
      } else {
        this.powerData = JSON.parse(JSON.stringify(this.powerDataCopy))
      }
    },

    // keyupEnter() {
    //   document.onkeydown = e => {
    //     if (e.keyCode === 13 && e.target.baseURI.match(/power/)) {
    //       this.searchUser()
    //     }
    //   }
    // },
  },
  created() {
    // this.filterHandler()
    // this.keyupEnter()
    this.setPowerArr()

    // console.log(this.userInfo)
    if (this.userInfo.admin) {
      for (const key in this.isShow) {
        this.isShow[key] = true
      }
      // this.formItems_organization.splice(0, 0, { type: 'number', key: 'show', label: '置顶权重' })
      // this.formItems_personal.splice(0, 0, { type: 'number', key: 'show', label: '置顶权重' })
    } else {
      const privilegesList = this.userInfo.privilegesList
      this.isShow.setVip = privilegesList.includes('user-vip')
      this.isShow.deleteUser = privilegesList.includes('service-delete-user')
      this.isShow.assignUser = privilegesList.includes('assign-user-to-work-person')
      this.isShow.assignOrganization = privilegesList.includes('assign-organization-to-work-person')
      this.isShow.modifyInfo = privilegesList.includes('user-info')
      this.isShow.modifyTopping = privilegesList.includes('user-show')
      // if (privilegesList.includes('user-show')) {
      //   this.formItems_organization.splice(0, 0, { type: 'number', key: 'show', label: '置顶权重' })
      //   this.formItems_personal.splice(0, 0, { type: 'number', key: 'show', label: '置顶权重' })
      // }
    }
  },
}
</script>

<style>
/* .index .index-header .el-form-item__content{width: 200px;} */

.input-with-select .el-input-group__prepend {background-color: #fff;}
.input-box{display:flex;flex-direction: row;justify-content: flex-start;}
.input-box>div{display:flex;flex-direction: column;}
.edit{padding-left: 15px;}
.edit-box{height: 100%;border: 1px solid #ccc;width: 100%;}
.edit-box .edit-item{display: flex;justify-content: flex-start;}
.edit-item .edit-left{flex: 0 0 50px;background: rgb(172, 237, 248);writing-mode:vertical-lr;text-align: center;line-height: 50px;color: black;}
.edit-item .edit-right{flex: 0 0 95%;}


.info-box{display: flex;justify-content: center;align-items: center;flex-direction: column;}
.info-input{margin-bottom: 80px;}
.info-title{text-align:center;margin:48px 0;color:rgb(153,153,153);}
.power-box{display: flex;justify-content: space-around;align-items: center;}
.power-left,.power-right{border-radius: 5px;height: 500px;width: 350px;overflow-y: auto;border: 1px solid #ccc;}
.power-left>div{height: 50px;line-height: 50px;margin-bottom: 10px;padding-left: 15px;cursor: pointer;font-size: 16px;font-weight: 500;}
.power-left>.active{background-color: #E9EEF3;color:#409EFF;}
.power-left>div:hover{background-color: #E9EEF3;color:#409EFF;}
</style>